"use client";

import React, { useState } from "react";
import { Terminal, ArrowRight, Cpu, CircleCheck, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogClose } from "@/components/ui/dialog";
export default function PartnerWithUs() {
  const [email, setEmail] = useState("");
  const [toolUrl, setToolUrl] = useState("");
  return <section id="partner-with-us" className="dark bg-background text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-[0.15]" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto">
        <Card className="bg-card/50 backdrop-blur-sm border-border/50 overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[400px]">
            {}
            <div className="lg:col-span-3 p-8 md:p-12 flex flex-col justify-center relative">
              {}
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-50 pointer-events-none" />
              
              <div className="relative space-y-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono tracking-wider uppercase">
                  <Terminal className="w-3 h-3" />
                  <span>Developer Portal</span>
                </div>

                <div className="space-y-4">
                  <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                    Are You Building the Future?
                  </h2>
                  <p className="text-lg text-muted-foreground max-w-md leading-relaxed">
                    Submit your tool for a professional lab review. We analyze architecture, performance, and usability to connect high-quality AI software with serious professionals.
                  </p>
                </div>

                <div className="flex flex-wrap gap-4 pt-4">
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button size="lg" className="h-12 px-8 text-base font-medium shadow-lg shadow-primary/20">
                        Submit Tool <ArrowRight className="ml-2 w-4 h-4" />
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="sm:max-w-[500px] bg-card border-border">
                      <DialogHeader>
                        <DialogTitle className="flex items-center gap-2">
                          <Cpu className="w-5 h-5 text-primary" />
                          Submit to The Lab
                        </DialogTitle>
                        <DialogDescription>
                          Enter your tool's details below. Our technical team reviews submissions weekly.
                        </DialogDescription>
                      </DialogHeader>
                      <div className="grid gap-6 py-4">
                        <div className="grid gap-2">
                          <label htmlFor="tool-name" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            Tool Name
                          </label>
                          <input id="tool-name" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="e.g. SuperAI 2.0" />
                        </div>
                        <div className="grid gap-2">
                          <label htmlFor="tool-url" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            Website URL
                          </label>
                          <input id="tool-url" value={toolUrl} onChange={e => setToolUrl(e.target.value)} className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="https://" />
                        </div>
                        <div className="grid gap-2">
                          <label htmlFor="email" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            Contact Email
                          </label>
                          <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="dev@company.com" />
                        </div>
                      </div>
                      <DialogFooter>
                        <DialogClose asChild>
                          <Button variant="outline">Cancel</Button>
                        </DialogClose>
                        <Button type="submit" onClick={() => alert("Thank you for your submission! Our team will review it shortly.")}>
                          <Send className="w-4 h-4 mr-2" /> Submit Request
                        </Button>
                      </DialogFooter>
                    </DialogContent>
                  </Dialog>
                  
                  <Button variant="ghost" className="h-12 px-6 text-muted-foreground hover:text-foreground" asChild>
                    <Link to="/ContactPage">
                      Contact Support
                    </Link>
                  </Button>
                </div>
              </div>
            </div>

            {}
            <div className="lg:col-span-2 bg-muted/30 border-t lg:border-t-0 lg:border-l border-border/50 p-8 flex flex-col justify-center relative overflow-hidden">
               {}
               <div className="absolute inset-0 opacity-10 font-mono text-[10px] leading-3 p-4 text-primary select-none pointer-events-none overflow-hidden whitespace-pre">
{`import { AI } from '@future/sdk';
const review = new LabReview({
  target: 'submission',
  metrics: ['speed', 'accuracy'],
  mode: 'strict'
});

await review.analyze();



`}
               </div>
               
               <div className="relative z-10 space-y-6">
                 <div className="space-y-2">
                   <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider">Review Criteria</h3>
                   <div className="h-px w-12 bg-primary/50" />
                 </div>
                 
                 <ul className="space-y-3">
                   {["Architecture Analysis", "Performance Benchmarks", "UX/UI Evaluation", "Market Viability", "Security Audit"].map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-sm text-muted-foreground">
                       <CircleCheck className="w-4 h-4 text-primary shrink-0" />
                       <span>{item}</span>
                     </li>)}
                 </ul>

                 <div className="pt-4">
                    <div className="p-4 rounded-lg bg-background/50 border border-border/50 backdrop-blur-sm">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                        <span className="text-xs font-mono text-muted-foreground">SYSTEM STATUS</span>
                      </div>
                      <p className="text-xs text-foreground font-medium">Accepting new submissions for Q3 2026 review cycle.</p>
                    </div>
                 </div>
               </div>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}